export default __webpack_public_path__ + "933442a5e5e209700158d20901bbead1.png";